enum AlertVariantType {
  SUCCESS = "success",
  INFO = "info",
  ERROR = "error",
  WARNING = "warning"
}
  
export { AlertVariantType };